module.exports = __webpack_public_path__ + "5646a7d33ac1901ca7ebe3cdee4ecf42.png";